import clevertap from "clevertap-web-sdk";
import { getCookie, NATIVE_DEVICE_INFO } from "./CSCookieHandler";
import { getMobileOperatingSystem } from "./helper";
import { T_OnUserLoginCleverTapStatic } from "../globalTypes/GlobalTypes";
import { nativeCallBackMethod } from "./NativeAppEvents";

declare const window: any;

export const Initialzation = () => {
  const CLEVERTAP_ACCOUNT_ID = "884-575-6R7Z";
  const CLEVERTAP_REGION = "in1";
  // Set privacy options
  clevertap.privacy.push({ optOut: false }); // Set to true if the user opts out of sharing their data
  clevertap.privacy.push({ useIP: true }); // Set to true if the user agrees to share their IP data

  // Initialize CleverTap
  clevertap.init(CLEVERTAP_ACCOUNT_ID, CLEVERTAP_REGION);
  clevertap.setLogLevel(3);
  clevertap.spa = true;
  sessionStorage.setItem("WZRK_D", ""); // Ensure the region is passed as an object
};

export type EventAttributes = {
  PageName?: string;
  isPrevPageNameRequired?: boolean;
  ScreenName?: string;
  ScreenType?: string;
  UserAction?: string;
  FormFieldTitle?: string;
  FormFieldValue?: string;
  ctaText?: string;
  ErrorMessage?: string;
  PolicyNumber?: string;
  PolicyStatus?: string;
  CardTitle?: string;
  CurrentPortfolioValue?: string;
  CardValue?: string;
  SectionTitle?: string;
  SearchText?: string;
  Pincode?: string;
  BranchName?: string;
  HospitalName?: string;
  PincodeLocationArea?: string;
  CityStateLocalityEntered?: string;
  FaqCategory?: string;
  FaqSubCategory?: string;
  SubCategory?: string;
  MainCategory?: string;
  OptionSelected?: string;
  QuestionText?: string;
  DrawerTitle?: string;
  DownloadMethod?: string;
  EmiAmount?: string;
  OutstandingAmount?: string;
  ServiceReqNumber?: string;
  LoanType?: string;
  ServiceStatus?: string;
  SanctionedAmount?: string;
  DisbursedAmount?: string;
  AccountStatus?: string;
  InsuringMembers?: string;
  PolicyTerm?: string;
  PlanName?: string;
  SumInsured?: string;
  PlanPremium?: string;
  Name?: string;
  Identity?: string;
  Email?: string;
  Phone?: string;
  Gender?: "M" | "F";
  DOB?: Date | "";
  MSG_email?: boolean;
  MSG_push?: boolean;
  MSG_sms?: boolean;
  MSG_whatsapp?: boolean;
  Stuff?: string;
};

type T_CleverTapBaseData = {
  ChannelID: string;
  UserAge: string;
  UserGender: string;
  ClientID: string;
  GoldenID: string;
  GuestID: string;
  $CleverTap_user_id: string;
  AppsflyerID: string;
  PlatformKey: string;
};
export class CleverTapBaseData {
  static lastEventFired: string = "";
  static eventObj: T_CleverTapBaseData = {
    ChannelID: "26",
    UserAge: "",
    UserGender: "",
    ClientID: "",
    GoldenID: "",
    GuestID: "",
    $CleverTap_user_id: "",
    AppsflyerID: "",
    PlatformKey: "",
  };
  static setBaseData(updatedEventObj: T_CleverTapBaseData) {
    this.eventObj = { ...updatedEventObj };
  }
  static setLastEventFired(eventName: string) {
    this.lastEventFired = eventName;
  }
}

export const triggerCleverTapEvent = (
  eventName: string,
  {
    PageName = "",
    isPrevPageNameRequired = false,
    ScreenName = "",
    ScreenType = "",
    UserAction = "",
    FormFieldTitle = "",
    FormFieldValue = "",
    ctaText = "",
    ErrorMessage = "",
    PolicyNumber = "",
    PolicyStatus = "",
    CardTitle = "",
    CurrentPortfolioValue = "",
    CardValue = "",
    SectionTitle = "",
    SearchText = "",
    Pincode = "",
    BranchName = "",
    HospitalName = "",
    PincodeLocationArea = "",
    CityStateLocalityEntered = "",
    FaqCategory = "",
    SubCategory = "",
    FaqSubCategory = "",
    MainCategory = "",
    OptionSelected = "",
    QuestionText = "",
    DrawerTitle = "",
    DownloadMethod = "",
    EmiAmount = "",
    OutstandingAmount = "",
    ServiceReqNumber = "",
    LoanType = "",
    ServiceStatus = "",
    SanctionedAmount = "",
    DisbursedAmount = "",
    AccountStatus = "",
    InsuringMembers = "",
    PolicyTerm = "",
    PlanName = "",
    SumInsured = "",
    PlanPremium = "",
    Name = "",
    Identity = "",
    Email = "",
    Phone = "",
    Gender = undefined,
    DOB = "",
    MSG_email = false,
    MSG_push = false,
    MSG_sms = false,
    MSG_whatsapp = false,
    Stuff = "",
  }: EventAttributes
) => {
  CleverTapBaseData.setLastEventFired(`${ScreenName} => ${eventName}`);
  if (
    ![
      "localhost",
      "sg-test.eastus.cloudapp.azure.com",
      "sitoneservice.adityabirlacapital.com",
      "uatoneservice.adityabirlacapital.com",
      "cugoneservice.adityabirlacapital.com",
      "oneservice.adityabirlacapital.com",
    ].includes(window.location.hostname)
  ) {
    return;
  }
  const eventData: any = CleverTapBaseData.eventObj;

  const attributes: any = {
    ScreenName,
    ScreenType,
    UserAction,
    FormFieldTitle,
    FormFieldValue,
    ctaText,
    ErrorMessage,
    PolicyNumber,
    PolicyStatus,
    CardTitle,
    CurrentPortfolioValue,
    CardValue,
    SectionTitle,
    SearchText,
    Pincode,
    BranchName,
    HospitalName,
    PincodeLocationArea,
    CityStateLocalityEntered,
    FaqCategory,
    SubCategory,
    FaqSubCategory,
    MainCategory,
    OptionSelected,
    QuestionText,
    DrawerTitle,
    DownloadMethod,
    EmiAmount,
    OutstandingAmount,
    ServiceReqNumber,
    LoanType,
    ServiceStatus,
    SanctionedAmount,
    DisbursedAmount,
    AccountStatus,
    InsuringMembers,
    PolicyTerm,
    PlanName,
    SumInsured,
    PlanPremium,
    Name,
    Identity,
    Email,
    Phone,
    Gender,
    DOB,
    MSG_email,
    MSG_push,
    MSG_sms,
    MSG_whatsapp,
    Stuff,
  };

  // Add dynamic attributes to eventData if they are not empty
  Object.keys(attributes).forEach((key) => {
    if (attributes[key] !== "") {
      eventData[key] = attributes[key];
    }
  });

  if (isPrevPageNameRequired) {
    const prevPageName = sessionStorage.getItem("prevPageName") || "";
    eventData.previousScreen = prevPageName;
  }

  if (ScreenName !== "") {
    sessionStorage.setItem("prevPageName", ScreenName);
  }

  const os =
    window.location.search.includes("device_info") ||
    getCookie(NATIVE_DEVICE_INFO)
      ? getMobileOperatingSystem() === "Android"
        ? "android"
        : "ios"
      : "web";

  console.info("Clever tap OS ", os);
  if (os === "web") {
    clevertap.event.push(eventName, eventData);
  } else if (os == "android") {
    let message: any = {};
    if (eventName === "onUserLogin") {
      message = {
        action: "CLEVER_TAP",
        eventName: "onUserLogin",
        eventData: eventData,
      };
    } else {
      message = {
        action: "CLEVER_TAP",
        eventName: eventName,
        eventData: eventData,
      };
    }
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify(message));
      console.log(
        "Sending event to TWA React Native Android " + JSON.stringify(message)
      );
    }
  } else {
    let message: any = {};
    if (eventName === "onUserLogin") {
      message = {
        type: "cleverTap",
        eventName: "onUserLogin",
        eventData: eventData,
      };
    } else {
      message = {
        type: "cleverTap",
        eventName: eventName,
        eventData: eventData,
      };
    }
    nativeCallBackMethod(message).then((response: any) => {
      console.log("Response from native code:", response);
    });
  }
};

// Enable Single Page Application (SPA) mode
clevertap.spa = true;

export default clevertap;

export const ServiceToggleInteraction = (value: boolean) => {
  clevertap.event.push("service_toggle_interaction", {
    UserAction: value === true ? "On" : "Off",
  });
};
